import Model from '@/lib/data/Model';

class FileTag extends Model {
    static idProperty = 'id';

    fields = [
        { name: 'id' },
        { name: 'file_storage_id' },
        { name: 'tag' },
        { name: 'record_state' },
    ];

    /**
     * Create the User object
     *
     * @param {Object} data - Seed data for this object.
     */
    constructor(data) {
        super(data);
        this.init();
    }

    api = [];
}

export default FileTag;
